import React, {useEffect} from "react";
import { Helmet } from "react-helmet-async";
const Contact = () => {
    


  return ( 
    <>
      <Helmet>
        <title>Contact DSAP Solutions | Audit & AI Consulting</title>

        <meta
          name="description"
          content="Contact DSAP Solutions for audit, compliance, AI software development, and enterprise digital solutions. Head office in Indore, India."
        />
      </Helmet>
      {/* PAGE HERO */}
      <section className="hero">
        <div className="container">
          <h1>Contact Us</h1>
          <p>
            Reach out to DSAP Solutions for audit, compliance,
            advisory, and AI-driven digital solutions.
          </p>
        </div>
      </section>

      {/* CONTACT DETAILS */}
      <section className="section">
        <div className="container">
          <h2>Head Office</h2>

          <div className="contact-box">
            <p>
              <strong>📍 Head Office:</strong><br />
              Office No. 09, 5th Floor, Malhar Mega Mall,<br />
              Scheme No. 54, Vijay Nagar, Indore (M.P.), India
            </p>

            <p>
              <strong>📞 Phone:</strong> +91 99932 15776
            </p>

            <p>
              <strong>📧 Email:</strong>{" "}
              <a href="mailto:info@dsapsolutions.in">
                info@dsapsolutions.in
              </a>
            </p>

         
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
